import { emptyItem } from '../adminForms/initials'

export const initialValues = { reason: emptyItem, isRequired: false }
